import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";

// Classes.
import { AthleteGeneralInfoItem } from "../fetching/types/athlete-general-info.item";
import { AthleteDetailedInfoItem } from "../fetching/types/athlete-detailed-info.item";
import { AthleteResultInfoItem } from "../fetching/types/athlete-result-info.item";
import { AthleteResultItem } from "../fetching/types/athlete-result.item";
import { AthleteResultInfoLiteItem } from "../fetching/types/athlete-result-info-lite.item";
import { TeamGeneralInfoItem } from "../fetching/types/team-general-info.item";
import { RankingItem } from "../fetching/types/ranking.item";
import { RankingCategoryItem } from "../fetching/types/ranking-category.item";
import { NewsItem } from "../fetching/types/news.item";
import { CategoryItem } from "../fetching/types/category.item";
import { CountryNameItem } from "../fetching/types/country-name.item";
import { EventGeneralInfoItem } from "../fetching/types/event-general-info.item";
import { RecordItem } from "../fetching/types/record.item";
import { RecordTeamItem } from "../fetching/types/record-team.item";
import { WCupSeasonItem } from "../fetching/types/wcup-season.item";
import { DivisionCategoryItem } from "../fetching/types/division.category.item";

// Services.
import { WABaseService } from "./wa-base.service";
import { LoggerService } from "../logger/logger-service";
import { WaHelperService } from "./wa-helper-service";
import { EnvironmentService } from "./environment-service";
import { SeriesAmateursDetailItem } from "../fetching/types/series-amateurs-detail-item";
import { SeriesAmateursRankingsItems } from "../fetching/types/series-amateurs-rankings.item";
import { SeriesTeamsRankingItems } from "../fetching/types/series-teams-rankings-item";
import { SeriesStagesItem } from "../fetching/types/series-stages.info.item";
import { SeriesAmateursItem } from "../fetching/types/series-amateurs-item";
import { RecordHistoryItem } from "../fetching/types/record-history.item";
import { SeriesItem } from "../fetching/types/series.item";
import { SeriesProItem } from "../fetching/types/series-pro.item";
import { CompetitionDisciplines } from '../fetching/types/competition-disciplines.item';
import { CompetitionLevelsItem } from '../fetching/types/competition-levels.item';

/**
 * Service to construct class instances that need providers injected.
 *
 * This is a service so it has DI, all providers are available.
 *
 */

@Injectable()
export class FactoryService extends WABaseService {

  constructor(
    protected logger: LoggerService,
    protected helper: WaHelperService,
    protected env: EnvironmentService
  ) {
    super(logger, env);
  }

  newCategoryItem(rawCategoryItem: any): CategoryItem {
    return new CategoryItem(rawCategoryItem);
  }

  newCountryNameItem(rawCountryNameItem: any): CountryNameItem {
    return new CountryNameItem(rawCountryNameItem);
  }

  newNewsItem(rawNewsItem: any): NewsItem {
    return new NewsItem(rawNewsItem, this.env, this.helper);
  }
  newRankingItem(rawWorldRankingItem: any): RankingItem {
    return new RankingItem(rawWorldRankingItem, this);
  }

  newAthleteResultInfoLiteItem(
    rawAthleteResultInfoLiteItem: any
  ): AthleteResultInfoLiteItem {
    return new AthleteResultInfoLiteItem(
      rawAthleteResultInfoLiteItem,
      this.helper
    );
  }

  newAthleteGeneralInfoItem(
    rawAthleteGeneralInfoItem: any
  ): AthleteGeneralInfoItem {
    return new AthleteGeneralInfoItem(rawAthleteGeneralInfoItem, this.helper);
  }

  newAthleteDetailedInfoItem(
    rawAthleteDetailedInfoItem: any
  ): AthleteDetailedInfoItem {
    return new AthleteDetailedInfoItem(
      rawAthleteDetailedInfoItem,
      this.helper,
      this
    );
  }

  newAthleteResultInfoItem(
    rawAthleteResultInfoItem: any
  ): AthleteResultInfoItem {
    return new AthleteResultInfoItem(
      rawAthleteResultInfoItem,
      this.helper,
      this
    );
  }

  newAthleteResultItem(rawAthleteResultItem: any): AthleteResultItem {
    return new AthleteResultItem(rawAthleteResultItem, this.helper, this);
  }

  newTeamGeneralInfoItem(rawTeamGeneralInfoItem: any): TeamGeneralInfoItem {
    return new TeamGeneralInfoItem(rawTeamGeneralInfoItem);
  }

  newRankingCategoryItem(rawRankingCategoryItem: any): RankingCategoryItem {
    return new RankingCategoryItem(rawRankingCategoryItem);
  }

  newEventGeneralInfoItem(rawEventGeneralInfoItem: any): EventGeneralInfoItem {
    return new EventGeneralInfoItem(rawEventGeneralInfoItem, this.helper);
  }

  newRecordItem(rawRecordItem: any): RecordItem {
    return new RecordItem(rawRecordItem, this);
  }

  newRecordTeamItem(rawRecordTeamItem: any): RecordTeamItem {
    return new RecordTeamItem(rawRecordTeamItem, this, this.helper);
  }

  newWCupSeasonItem(rawWCupSeasonItem: any): WCupSeasonItem {
    return new WCupSeasonItem(rawWCupSeasonItem);
  }
  newSeriesStageItem(rawSeriesStateItem: any): SeriesStagesItem {
    return new SeriesStagesItem(rawSeriesStateItem, this.helper);
  }
  newSeriesAmateursDetailItem(
    rawSeriesAmateursDetailItem: any
  ): SeriesAmateursDetailItem {
    return new SeriesAmateursDetailItem(
      rawSeriesAmateursDetailItem,
      this.helper
    );
  }
  newSeriesAmateursItem(
    rawSeriesAmateursRankingsItems: any
  ): SeriesAmateursItem {
    return new SeriesAmateursItem(rawSeriesAmateursRankingsItems, this);
  }
  newSeriesTeamsRankingItems(
    rawSeriesTeamsRankingItems: any
  ): SeriesTeamsRankingItems {
    return new SeriesTeamsRankingItems(rawSeriesTeamsRankingItems, this);
  }
  newRecordHistoryItems(rawRecordHistoryItems: any) {
    return new RecordHistoryItem(rawRecordHistoryItems, this);
  }
  newSeriesItem(rawItem: any) {
    return new SeriesItem(rawItem);
  }
  newSeresProItems(rawItem: any) {
    return new SeriesProItem(rawItem, this);
  }
  newCompetitionDisciplines(rawItem: any) {
    return new CompetitionDisciplines(rawItem);
  }
  newCompetitionLevels(rawItem: any): CompetitionLevelsItem {
    return new CompetitionLevelsItem(rawItem);
  }
  newDivisionCategory(rawItem: any): DivisionCategoryItem {
    return new DivisionCategoryItem(rawItem);
  }
}
